// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__fcmHg","rootNoMargin":"styles_rootNoMargin__V9kH9"};